export class CookieDescription {
  public key: string;
  public isRequired: boolean;
  public headlineText: string;
  public descriptionText: string;
  public overlayHeadlineText: string;
  public overlayDescriptionText: string;
  public overlayButtonText: string;
  public infoUrl: string;
  public userPermission: boolean;

  constructor(values: any) {
    this.key = values.key;
    this.isRequired = values.isRequired;
    this.headlineText = values.headlineText;
    this.descriptionText = values.descriptionText;
    this.overlayHeadlineText = values.overlayHeadlineText;
    this.overlayDescriptionText = values.overlayDescriptionText;
    this.overlayButtonText = values.overlayButtonText;
    this.infoUrl = values.infoUrl;
    this.userPermission = values.userPermission
  }
}

export class TrackPageEvent {
  path: string;
  title: string;

  constructor(path, title) {
    this.path = path;
    this.title = title;
  }

}

export class TrackClickEvent {
  action: string;
  category: string;
  label: string;
  value: string;
  isSale: string;
  likeOrigin: string;
  imageType: string;

  constructor(values) {
    this.action = values.action;
    this.category = values.category;
    this.label = values.label;
    this.value = values.value;
    this.isSale = values.isSale;
    this.likeOrigin = values.likeOrigin;
    this.imageType = values.imageType;
  }

}

export type TrackingEvent = TrackPageEvent | TrackClickEvent;
